var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", {}, [
    _c("div", { staticClass: "gallery-header" }, [
      _c("div", { staticClass: "gallery-header-left" }, [
        _c("div", {
          staticClass: "logo icon-fan-logo",
          attrs: { "aria-label": "Fan Logo" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.options.GalleryTitle)),
        ]),
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "close",
        attrs: { tabindex: "0", "aria-label": _vm.options.Close },
        on: {
          click: function ($event) {
            _vm.unSetCurrentImage()
            _vm.scrollToImage()
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "gallery-mediaview-track",
        class: { isvideo: _vm.currentItem.IsVideo },
      },
      [
        _c(
          "transition",
          { attrs: { name: "gallery-slide-" + _vm.slideDirection } },
          [
            _vm.currentItem
              ? _c(
                  "div",
                  {
                    key: _vm.currentItem.Id,
                    staticClass: "gallery-mediaview-wrapper",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "gallery-mediaview" },
                      [
                        !_vm.currentItem.IsVideo
                          ? _c(
                              "picture",
                              {
                                directives: [
                                  {
                                    name: "lazyload",
                                    rawName: "v-lazyload",
                                    value: {
                                      src: "" + _vm.currentItem.ImageSrc,
                                      set: [{ height: 1000 }],
                                      fit: "crop",
                                      align: "center",
                                    },
                                    expression:
                                      "{\n                  src: `${currentItem.ImageSrc}`,\n                  set: [\n                    { height: 1000},\n                  ],\n                  fit: 'crop',\n                  align: 'center'\n                }",
                                  },
                                ],
                                staticClass: "image-wrapper",
                              },
                              [
                                _c("img", {
                                  staticClass: "image",
                                  attrs: {
                                    src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                                    alt: _vm.currentItem.Title,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentItem.IsVideo
                          ? _c("video-player", {
                              attrs: {
                                "desktop-video": _vm.currentItem.DesktopVideo,
                                "desktop-video-poster-image":
                                  _vm.currentItem.DesktopVideoPosterImage !== ""
                                    ? _vm.currentItem.DesktopVideoPosterImage
                                    : _vm.options.GalleryMissingImage,
                                "is-background-video": false,
                                dictionary: _vm.videoPlayerDictionary,
                                "alt-text": _vm.currentItem.Title,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.currentItem.Title.length
                      ? _c("div", { staticClass: "gallery-mediaview-info" }, [
                          _c("div", { staticClass: "gallery-item-title" }, [
                            _vm._v(_vm._s(_vm.currentItem.Title)),
                          ]),
                          _vm._v(" "),
                          _vm.currentItem.ShortDescription.length
                            ? _c(
                                "div",
                                { staticClass: "gallery-item-description" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.currentItem.ShortDescription) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentItem.CtaUrl.length
                            ? _c("div", { staticClass: "gallery-item-cta" }, [
                                _c("a", {
                                  attrs: {
                                    href: _vm.currentItem.CtaUrl,
                                    target: _vm.currentItem.CtaTarget,
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentItem.CtaText != ""
                                        ? _vm.currentItem.CtaText
                                        : _vm.options.LearnMore
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "gallery-arrows-wrapper" }, [
      _c("button", {
        staticClass: "gallery-imageview-arrows gallery-imageview-prev",
        attrs: {
          tabindex: "0",
          "aria-label":
            _vm.options.Previous +
            " " +
            _vm.previousItemNumber +
            "/" +
            _vm.totalImages +
            " " +
            _vm.previousItem.Title,
        },
        on: { click: _vm.goToPrev },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pagination",
          attrs: {
            tabindex: "0",
            "aria-label": _vm.currentItemNumber + "/" + _vm.totalImages,
          },
        },
        [_vm._v(_vm._s(_vm.currentItemNumber) + "/" + _vm._s(_vm.totalImages))]
      ),
      _vm._v(" "),
      _c("button", {
        staticClass: "gallery-imageview-arrows gallery-imageview-next",
        attrs: {
          tabindex: "0",
          "aria-label":
            _vm.options.Next +
            " " +
            _vm.nextItemNumber +
            "/" +
            _vm.totalImages +
            " " +
            _vm.nextItem.Title,
        },
        on: { click: _vm.goToNext },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }